import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { isRTL } from "../../../utils";

export default function Form({ show, children, other, className }) {
	let width = !other ? "form-width" : "other-width";
	return (
		<>
			<Offcanvas
				show={show}
				backdrop="static"
				placement={isRTL ? "start" : "end"}
				className={`${width} ${className} overflow-y-scroll`}
			>
				{children}
			</Offcanvas>
		</>
	);
}
